import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M20 6 9 17l-5-5"/>
</svg>`;

const Checkmark = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='checkmark' svg={svg} {...props} />
  )
);

Checkmark.displayName = 'CheckmarkIcon';

export default Checkmark;
